import { styledComponent } from '../../styles/styled'
import { Box } from '../Box'

export const ImageContainer = styledComponent(Box, {
  shouldForwardProp: (prop) => prop !== 'dominantColor'
})<{ dominantColor?: string | null }>(({ dominantColor }) => ({
  width: '100%',
  height: '100%',
  position: 'relative',
  borderRadius: '8px',
  backgroundColor: dominantColor ? `${dominantColor}35` : ''
}))

export const ImageWrapper = styledComponent(Box, {
  shouldForwardProp: (prop) => prop !== 'disableShadow'
})<{ disableShadow: boolean }>(({ disableShadow }) => ({
  position: 'relative',
  filter: disableShadow ? 'drop-shadow(8px 8px 32px rgba(0, 0, 0, 0))' : 'drop-shadow(8px 8px 32px rgba(0, 0, 0, 0.2))',
  width: '100%',
  height: '100%',
  zIndex: 2,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
}))
